module.exports = __webpack_public_path__ + "img/center-2015-workshop.8b596be7.jpg";